import { ISku, ISkuVariantWithSku, ListSkus, SkuFilters, SkuStatusEnum, TSku } from "models/inventory/interfaces/sku.interface";
import { fetchSkusGraphql } from "apolloClient";
import { cleanBrands, cleanCylindersFilters, cleanModels, cleanYears } from "../../../helpers/formatFilters";
import { PandaboardApiInstance } from "../../../helpers/api";

export const getSkus = async (filters: Partial<SkuFilters> = {}): Promise<ListSkus> => {
  const { getAllSkus } = await fetchSkusGraphql({ status: SkuStatusEnum.ACTIVE, ...filters });
  const ccs = cleanCylindersFilters(getAllSkus.filters.cc);
  const years = cleanYears(getAllSkus.filters.years);
  const models = cleanModels(getAllSkus.filters.models);
  const brands = cleanBrands(getAllSkus.filters.models);

  const skus = getAllSkus.data.map((item: ISku) => new TSku(item));

  return {
    skus,
    filters: {
      brands,
      models,
      years,
      ccs,
      priceMin: getAllSkus.filters.minPrice ?? null,
      priceMax: getAllSkus.filters.maxPrice ?? null,
    },
    page: getAllSkus.page,
    pages: getAllSkus.pages,
    count: getAllSkus.count,
  };
};

export const getSkuByCode = (code: string): Promise<TSku | null> =>
  PandaboardApiInstance
    .get(`skus/code/${code}/public`)
    .then((response) => new TSku(response.data))
    .catch(() => null);

export const getPublicSkuVariant = (skuId: string, variantId: string): Promise<ISkuVariantWithSku | null> =>
  PandaboardApiInstance
    .get(`skus/${skuId}/variants/${variantId}/public`)
    .then((response) => response.data)
    .catch(() => null);

export const getRecommendedSkus = (limit: number): Promise<TSku[]> =>
  PandaboardApiInstance
    .get("skus/recommended", { params: { limit } })
    .then((response) => response.data.map((item: ISku) => new TSku(item)))
    .catch(() => [] as TSku[]);
